<template>
    <div class="container">
        请在手机打开网页链接
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    created () {

    },
    methods: {

    },
}
</script>

<style lang="less" scoped>

</style>
